module.exports = __webpack_public_path__ + "static/media/home-presentation-image-02.269c71f6.jpg";